import { searchExternalPlaces } from 'api/external-search'
import { MapQueryParams, UnreportedPlaceCandidate } from 'infra/type'

export const crawlNaver = async (
  queryParams: MapQueryParams,
): Promise<UnreportedPlaceCandidate[]> =>
  searchExternalPlaces('naver', queryParams)
